import React from 'react';
import styles from './JobFitColumn.module.css';

const JobFitColumn = ({ title, subtitle, sections }) => {
    if (!sections || sections.length === 0) {
        return (
            <div className={styles.column}>
                <div className={styles.columnHeader}>
                    <h3 className={styles.columnTitle}>{title}</h3>
                    {subtitle && <p className={styles.columnSubtitle}>{subtitle}</p>}
                </div>
                <div className={styles.emptyState}>
                    <p>No data available</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.column}>
            <div className={styles.columnHeader}>
                <h3 className={styles.columnTitle}>{title}</h3>
                {subtitle && <p className={styles.columnSubtitle}>{subtitle}</p>}
            </div>

            <div className={styles.sectionsContainer}>
                {sections.map((section, idx) => (
                    <div key={idx} className={styles.section}>
                        <h4 className={styles.sectionTitle}>{section.heading || section.title || 'Section'}</h4>

                        {/* Handle 'lines' from API response */}
                        {section.lines && section.lines.length > 0 && (
                            <ul className={styles.itemsList}>
                                {section.lines.map((line, lineIdx) => (
                                    <li
                                        key={lineIdx}
                                        className={`${styles.item} ${line.status === 'match' ? styles.itemMatched :
                                                line.status === 'missing' ? styles.itemMissing : ''
                                            }`}
                                    >
                                        <span className={styles.itemText}>{line.text}</span>
                                        {line.status === 'match' && <span className={styles.badge}>✓</span>}
                                        {line.status === 'missing' && <span className={styles.badgeMissing}>✗</span>}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {/* Fallback for 'items' structure */}
                        {section.items && section.items.length > 0 && (
                            <ul className={styles.itemsList}>
                                {section.items.map((item, itemIdx) => (
                                    <li
                                        key={itemIdx}
                                        className={`${styles.item} ${item.matched ? styles.itemMatched :
                                                item.missing ? styles.itemMissing : ''
                                            }`}
                                    >
                                        <span className={styles.itemText}>{item.text || item}</span>
                                        {item.matched && <span className={styles.badge}>✓</span>}
                                        {item.missing && <span className={styles.badgeMissing}>✗</span>}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {section.content && (
                            <p className={styles.sectionContent}>{section.content}</p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default JobFitColumn;
